import { Lightning, Router } from "@lightningjs/sdk";
import { exoplayer } from "@sa-team/kotlin-commuter-sdk";
import { map } from "rxjs/operators";
import { VideoPlayerEventNames } from "../base";
const events = {
    ended: VideoPlayerEventNames.Ended,
    pause: VideoPlayerEventNames.Pause,
    playing: VideoPlayerEventNames.Playing,
    seeked: VideoPlayerEventNames.Seeked,
    seeking: VideoPlayerEventNames.Seeking,
    timeupdate: VideoPlayerEventNames.TimeUpdate,
};
export class ExoPlayerVideoPlayer extends Lightning.Component {
    constructor() {
        super(...arguments);
        this._currentTime = 0;
        this._href = "";
        this._subscriptions = [];
        this.buffering$ = exoplayer.buffering$;
        this.currentTime$ = exoplayer.currentTime$;
        this.duration$ = exoplayer.duration$;
        this.events$ = exoplayer.events$.pipe(map((event) => events[event]));
        this.playing$ = exoplayer.playing$;
    }
    get href() {
        return this._href;
    }
    set href(href) {
        this._href = href;
    }
    _addSub(observable, callback) {
        this._subscriptions.push(observable.subscribe(callback));
    }
    _active() {
        this._addSub(exoplayer.currentTime$, (currentTime) => {
            this._currentTime = currentTime;
        });
    }
    _inactive() {
        this._subscriptions.forEach((s) => s.unsubscribe());
        exoplayer.stop();
    }
    pause() {
        exoplayer.pause();
    }
    play() {
        exoplayer.play();
    }
    seekTo(time) {
        exoplayer.seekTo(time);
    }
    skip(delta) {
        exoplayer.seekTo(this._currentTime + delta);
    }
    startPlayback() {
        if (this._href) {
            exoplayer.addMediaItem(this._href);
            exoplayer.play();
        }
        else {
            Router.back();
        }
    }
    stop() {
        exoplayer.stop();
    }
}
export default ExoPlayerVideoPlayer;
//# sourceMappingURL=ExoPlayerVideoPlayer.js.map